import { RESET_STATE } from 'store/global/actions';

import { SUB_COMPANY_TASK_USERS_ACTION_TYPE } from '../actions';

const initialState = [];

const subCompanyTaskUsersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SUB_COMPANY_TASK_USERS_ACTION_TYPE.GET_USERS:
      return payload || initialState;

    case SUB_COMPANY_TASK_USERS_ACTION_TYPE.RESET_STATE:
    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default subCompanyTaskUsersReducer;
